// extracted by mini-css-extract-plugin
export default {"Loader":"Loader_Loader__5tPVb","LoaderIcon":"Loader_LoaderIcon__RKUdY","spinner":"Loader_spinner__wDq1e"};